import React, { useState, useEffect } from "react";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  Divider,
  Snackbar,
  Box,
  Typography,
  Button,
  Alert,
} from "@mui/material";
import { zhTW } from "date-fns/locale";
import { format } from "date-fns";
import { useTheme } from "@mui/material/styles";

function CheckoutDrawer({
  storeName,
  table,
  total,
  startTime,
  endTime,
  priceIndex,
  nextStep,
  onlinePaymentAvailable = false,
}) {
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState("");
  const theme = useTheme();

  useEffect(() => {
    setSnakeMsg("");
    setSnakeOpen(false);
  }, [endTime]);

  const handleCheckoutClicked = () => {
    nextStep(table.SimulatorId, table.PriceTable.PlanId[priceIndex]);
  };

  const getDayInChinese = (date) => {
    const days = ["日", "一", "二", "三", "四", "五", "六"];
    return days[date.getDay()];
  };

  const formatDateToCustomString = (date) => {
    if (!(date instanceof Date)) return "未選擇";
    const monthDay = format(date, "MM/dd", { locale: zhTW });
    const chineseDay = getDayInChinese(date);
    const time = format(date, "HH:mm", { locale: zhTW });
    return `${monthDay}(${chineseDay}) ${time}`;
  };

  const main = theme.palette.info.main;

  return (
    <>
      <Box
        borderTop={1}
        borderColor={main}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100vw",
          height: 80,
          zIndex: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: theme.palette.background.default,

        }}
      >
        {/* 場地名稱 */}
        <Box
          ml={1}
          minWidth={60}
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            align="center"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "14pt",
            }}
          >
            {storeName}
          </Typography>
          <Typography
            align="center"
            sx={{
              color: theme.palette.text.secondary,
              fontWeight: 600,
              fontSize: "12pt",
            }}
          >
            {table ? table.Name : null}
          </Typography>
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          sx={{ bgcolor: main, mx: 1, my: 1.5, opacity: 0.6 }}
        />

        {/* 時間區 */}
        <Box
          width="36%"
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          ml={1}
        >
          <Box width="max-content">
            <Typography
              align="center"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
                fontSize: "12pt",
                letterSpacing: 1,
              }}
            >
              {formatDateToCustomString(startTime)}
            </Typography>

            <Box display="flex" justifyContent="center" width="100%">
              <ArrowDownwardIcon fontSize="small" sx={{ color: main }} />
            </Box>

            <Typography
              align="center"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
                fontSize: "12pt",
                letterSpacing: 1,
              }}
            >
              {formatDateToCustomString(endTime)}
            </Typography>
          </Box>
        </Box>

        {/* 價格、結帳按鈕區 */}
        <Box
          width="28%"
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          mr={2}
        >
          <Typography
            align="left"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "14pt",
              mb: "4px",
            }}
          >
            總計${total}
          </Typography>

          {/* <Button
            variant="contained"
            onClick={handleCheckoutClicked}
            disabled={
              endTime === null || startTime === null || !onlinePaymentAvailable
            }
            startIcon={<ShoppingCartCheckoutIcon />}
            sx={{
              fontSize: "14pt",
              fontWeight: "bold",
              backgroundColor: main,
              color: theme.palette.text.selected, // white
              borderRadius: "999px",
              px: 2.2,
              py: 0.7,
              boxShadow: `0 2px 12px ${main}40`,
              textTransform: "none",
              "&:hover": {
                backgroundColor: theme.palette.info.dark ?? main,
              },
              "&.Mui-disabled": {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.text.disabled,
              },
            }}
          >
            {onlinePaymentAvailable ? "結帳" : "無"}
          </Button> */}
        </Box>
      </Box>

      <Snackbar
        sx={{ mb: "11vh" }}
        open={snakeOpen}
        autoHideDuration={2500}
        onClose={(_, reason) => {
          if (reason === "clickaway") setSnakeOpen(false);
        }}
        message={snakeMsg}
      >
        <Alert
          onClose={(_, reason) => {
            if (reason === "clickaway") setSnakeOpen(false);
          }}
          severity="warning"
          sx={{
            width: "60%",
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          {snakeMsg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default CheckoutDrawer;
